// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_jl-6";
export var emphasizeQuantity = "_jl-3";
export var flatBottomCorners = "_jl-5";
export var productImage = "_jl-0";
export var quantityContainer = "_jl-2";
export var tooltip = "_jl-1";
export var wrapAndEllipsesOverflow = "_jl-4";